import { tx as translateInterfaceText } from '@/utils/i18n';
import { useLanguage } from '@/hooks/useLanguage';
import React, { useState } from 'react';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { Button } from '@/components/ui/button';
import { Monitor, Smartphone } from 'lucide-react';
import { OfferCard } from './OfferCard';
import { OfferModalDemo } from './OfferModalDemo';
import { WebinarOffer } from '@/store/webinar/types';

interface OfferPreviewProps {
  data: Partial<WebinarOffer>;
}

export function OfferPreview({ data }: OfferPreviewProps) {
  useLanguage();
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <div className="space-y-4">
      <Tabs defaultValue="desktop" className="w-full">
        <TabsList className="grid w-full grid-cols-2">
          <TabsTrigger value="desktop" className="gap-2">
            <Monitor className="h-4 w-4 text-muted-foreground" />
            {translateInterfaceText("Desktop")}</TabsTrigger>
          <TabsTrigger value="mobile" className="gap-2">
            <Smartphone className="h-4 w-4 text-muted-foreground" />
            {translateInterfaceText("Mobile")}</TabsTrigger>
        </TabsList>

        <TabsContent value="desktop" className="mt-4">
          <div className="border rounded-lg p-6 bg-muted/20">
            <OfferCard variant="desktop" data={data} />
          </div>
        </TabsContent>

        <TabsContent value="mobile" className="mt-4">
          <div className="border rounded-lg p-6 bg-muted/20 flex justify-center">
            <OfferCard variant="mobile" data={data} />
          </div>
        </TabsContent>
      </Tabs>

      <Button 
        variant="outline" 
        className="w-full"
        onClick={() => setIsModalOpen(true)}
      >
        {translateInterfaceText("Testar abertura do modal")}</Button>

      <OfferModalDemo 
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        data={data}
      />
    </div>
  );
}
